export default {
  metadata: null,
  passage: null,
  libraryTree: null,
  displayMode: 'default',
  selectedNamedEntities: [],
};
